import React from 'react';

import {IMaskInput} from 'react-imask';

const PhoneMaskedInput = React.forwardRef<HTMLInputElement, any>(
  (props, ref) => {
    return (
      <IMaskInput
        {...props}
        inputRef={ref}
        mask="(000) 000-0000"
      />
    );
  },
);

export default PhoneMaskedInput;
